type WithId = { id?: string | null };

/**
 * The AI provider a new solution is created with. The backend builds the
 * Supervisor + Knowledge Agent template only when `createSolution` gets an
 * `llmCredentialId`, so with several providers and no pick the first is used
 * (as the conversational create does) rather than none.
 */
export const pickLlmCredentialId = (
  credentials: readonly WithId[] | null | undefined,
  picked?: string
): string | undefined => {
  if (picked && credentials?.some((c) => c.id === picked)) return picked;
  return credentials?.[0]?.id || undefined;
};

/** A project with no AI provider can only get the agentless fallback. */
export const canCreateWithCredentials = (
  credentials: readonly WithId[] | null | undefined
): boolean => !!pickLlmCredentialId(credentials);
